import React from "react";
import "./../../assets/styles/custom/components/Footer.scss";
const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-items_report">
        <a href="mailto:support@amiagi.com"> Report Issues </a>
      </div>
      <div className="footer_row_1">
        <div className="footer-items">© 2021 AmiAgi aaTms</div>
        <div className="footer-items">{new Date().toUTCString()}</div>
        <div className="footer-items">
          <div className="footer-logo">
            <img src="../AMIAGI.png" alt="aaTms" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
